import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { UserSettingModel } from '../../../../models/informate';

@Component({
    selector: 'app-calculation-preferences',
    templateUrl: './calculation-preferences.component.html',
    styleUrls: ['./calculation-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CalculationPreferencesComponent implements OnChanges, OnInit {
    @Input() form: UntypedFormGroup;
    @Input()
    set dataSource(value: UserSettingModel[]) {
        this._dataSource = value;
    }
    get dataSource(): UserSettingModel[] {
        return this._dataSource;
    }

    passPercentageData: UserSettingModel[];
    calcResultsData: UserSettingModel[];
    otherData: UserSettingModel[];
    private _dataSource: UserSettingModel[];
    ngOnInit(): void {
        if (!this.dataSource?.length) return;
        this.initialise();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dataSource.firstChange) return;
        this.initialise();
    }

    initialise(): void {
        this.passPercentageData = this.getSectionData('Pass Percentage', true);
        this.calcResultsData = this.getSectionData('Calculation Results', true);
        this.otherData = this.getSectionData('Other', true);
    }

    getSectionData(sectionName: string, isSubSection: boolean = false): UserSettingModel[] {
        const sections: UserSettingModel[] = this.dataSource.filter((item: UserSettingModel) => {
            if (isSubSection) {
                return item.setting.settingSubSection?.name.toLowerCase() === sectionName.toLowerCase();
            }

            return item.setting.settingSubSection?.settingSection.name.toLowerCase() === sectionName.toLowerCase();
        });

        return sections;
    }
}
